import { Head, Link } from '@inertiajs/react';
import { Rule, Section } from '../Components';
import { Banner, BannerHeader, BannerText } from '../Components/Banners';

export default function Missing() {
    return (
        <>
            <Head>
                <title>404</title>
                <meta name='description' content='Page could not be found.' />
            </Head>

            <Banner className='py-38'>
                <BannerHeader>404</BannerHeader>
                <Rule className='mx-auto w-1/2 max-w-60' />
                <BannerText> Page Could Not Be Found</BannerText>
            </Banner>

            <Section id='page-not-found' className='py-12 lg:py-20'>
                <div className='w-full max-w-full prose-h2:text-3xl prose-h2:lg:text-4xl text-center prose'>
                    <h3>The page you were looking for could not be found</h3>
                    <p>
                        Please return to the{' '}
                        <Link
                            href='/'
                            title='Onward Travel Solutions Ltd Homepage'
                        >
                            Homepage
                        </Link>{' '}
                        or{' '}
                        <Link
                            href='/drivers'
                            title="Onward Travel Solutions Driver's Information"
                        >
                            Driver's Page
                        </Link>{' '}
                        for more information.
                    </p>
                </div>
            </Section>
        </>
    );
}
